<!--
 * @Author: your name
 * @Date: 2020-07-23 19:19:48
 * @LastEditTime: 2020-07-23 19:55:25
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /x-product-h5-workspace/packages/xdap-h5/src/lib/ui/components/x-input/x-input.vue
-->
<template>
  <div class="x-input">
    <cube-input v-model="value" ></cube-input>
  </div>
</template>

<script>
export default {
  name: 'XInput',
  data() {
    return {
      value: ''
    }
  }
}
</script>

<style>

</style>